"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6315],{

/***/ 38634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useGetSingleTopicProgress; },
/* harmony export */   "v": function() { return /* binding */ useGetTopicsProgress; }
/* harmony export */ });
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71529);


var basePath = "/microlearnings";
function useGetTopicsProgress(isTriggered) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("".concat(basePath, "/topics/progress"), {
        queryConfig: {
            enabled: isTriggered,
            useErrorBoundary: false
        },
        errorHandlerFn: function(status, path, error) {
            (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .handleCommonErrors */ .CI)(status !== null && status !== void 0 ? status : 500, path, error);
        }
    });
}
function useGetSingleTopicProgress(moduleId, isTriggered) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("".concat(basePath, "/topics/").concat(moduleId, "/progress"), {
        queryConfig: {
            enabled: !!moduleId && isTriggered
        },
        errorHandlerFn: function(status, path, error) {
            (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .handleCommonErrors */ .CI)(status !== null && status !== void 0 ? status : 500, path, error);
        }
    });
}


/***/ }),

/***/ 14644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cz": function() { return /* binding */ useGetTopicAksiNyataSession; },
/* harmony export */   "Ht": function() { return /* binding */ useTriggerGenerateCertificatePdf; },
/* harmony export */   "Lr": function() { return /* binding */ useTopicProgress; },
/* harmony export */   "MD": function() { return /* binding */ useTopicNewest; },
/* harmony export */   "Sw": function() { return /* binding */ useGetTopicDetail; },
/* harmony export */   "TA": function() { return /* binding */ useGetRelevanceTopic; },
/* harmony export */   "Ti": function() { return /* binding */ usePostAksiNyataAppeal; },
/* harmony export */   "W0": function() { return /* binding */ usePostAksiNyata; },
/* harmony export */   "XI": function() { return /* binding */ useGetTopicList; },
/* harmony export */   "YK": function() { return /* binding */ usePostTopicCertificate; },
/* harmony export */   "bJ": function() { return /* binding */ useGetCertificate; },
/* harmony export */   "bt": function() { return /* binding */ useGetAksiNyataRevision; },
/* harmony export */   "gb": function() { return /* binding */ useGetTopicAksiNyataOptions; },
/* harmony export */   "l4": function() { return /* binding */ usePostCertificate; },
/* harmony export */   "nL": function() { return /* binding */ useTopicCertificate; },
/* harmony export */   "oq": function() { return /* binding */ useTopicRecommendation; },
/* harmony export */   "w3": function() { return /* binding */ JenjangUnmatched; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25171);
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71529);
/* harmony import */ var utils_customError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97512);






var JenjangUnmatched = /*#__PURE__*/ function(CustomError) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(JenjangUnmatched, CustomError);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(JenjangUnmatched);
    function JenjangUnmatched(apiPath, originalError) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, JenjangUnmatched);
        var title = "Jenjang tidak sesuai";
        var description = "Topik yang anda akses tidak sesuai dengan jenjang akun anda.";
        return _super.call(this, {
            title: title,
            description: description,
            apiPath: apiPath,
            originalError: originalError
        });
    }
    return JenjangUnmatched;
}(utils_customError__WEBPACK_IMPORTED_MODULE_4__/* .CustomError */ .sH);
function useGetTopicList() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics", {
        errorHandlerFn: function(status, path, error) {
            (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .handleCommonErrors */ .CI)(status !== null && status !== void 0 ? status : 500, path, error);
        }
    });
}
function useGetTopicDetail(topicId) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId), {
        queryConfig: {
            enabled: !!topicId
        },
        errorHandlerFn: function(status, path, error, errorResponse) {
            var ref, ref1, ref2, ref3;
            if (status === 400 && !!((ref1 = (ref = errorResponse.data) === null || ref === void 0 ? void 0 : ref.errors[0]) === null || ref1 === void 0 ? void 0 : ref1.code) && ((ref3 = (ref2 = errorResponse.data) === null || ref2 === void 0 ? void 0 : ref2.errors[0]) === null || ref3 === void 0 ? void 0 : ref3.code) === "08-118") {
                throw new JenjangUnmatched(path, error);
            } else {
                (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .handleCommonErrors */ .CI)(status !== null && status !== void 0 ? status : 500, path, error);
            }
        }
    });
}
function useGetTopicAksiNyataOptions(topicId, enabled) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata-options"), {
        queryConfig: {
            enabled: !!topicId && enabled
        }
    });
}
function useGetTopicAksiNyataSession(topicId, enabled) {
    var data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata"), {
        queryConfig: {
            enabled: !!topicId && enabled,
            useErrorBoundary: false
        },
        axiosConfig: {
            data: data
        }
    });
}
function usePostAksiNyata(topicId, method, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata"), {
        mutationConfig: opts,
        axiosConfig: {
            method: method
        }
    });
}
function useGetRelevanceTopic(topicId) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/relevances"), {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}
function useGetAksiNyataRevision(topicId, enabled) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata/revision"), {
        queryConfig: {
            enabled: !!topicId && enabled,
            useErrorBoundary: false
        }
    });
}
function usePostCertificate(topicId, method, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/certificate"), {
        mutationConfig: opts,
        axiosConfig: {
            method: method
        }
    });
}
function useGetCertificate(param) {
    var enabled = param.enabled, errorHandler = param.errorHandler, refetchInterval = param.refetchInterval, topicId = param.topicId;
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/certificate"), {
        axiosConfig: {
            method: "GET"
        },
        queryConfig: {
            enabled: !!topicId && enabled,
            useErrorBoundary: false,
            refetchInterval: refetchInterval
        },
        errorHandlerFn: function(_status, _path, error, errorResponse) {
            var errorCode = errorResponse.data.errors[0].code;
            errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(errorCode, error);
        }
    });
}
function useTriggerGenerateCertificatePdf(topicId, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/certificate/rerender"), {
        mutationConfig: opts,
        axiosConfig: {
            method: "POST"
        }
    });
}
function usePostAksiNyataAppeal(topicId, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata/appeal"), {
        mutationConfig: opts,
        axiosConfig: {
            method: "POST"
        }
    });
}
function useTopicNewest() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topic-recommendation", {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}
function useTopicRecommendation() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/section-page", {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}
function useTopicProgress() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/progress", {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}
function useTopicCertificate(param) {
    var topicId = param.topicId, errorHandler = param.errorHandler;
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/surat-selesai-belajar"), {
        queryConfig: {
            enabled: !!topicId,
            useErrorBoundary: false
        },
        errorHandlerFn: function(_status, _path, error, errorResponse) {
            var errorCode = errorResponse.data.errors[0].code;
            errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(errorCode, error);
        }
    });
}
function usePostTopicCertificate(topicId, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/surat-selesai-belajar"), {
        mutationConfig: opts,
        axiosConfig: {
            method: "POST"
        }
    });
}


/***/ }),

/***/ 18248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var app_PelatihanMandiriPage_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30469);
/* harmony import */ var api_microlearning_useAPIProgress__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38634);
/* harmony import */ var api_microlearning_useAPITopics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14644);




var useTopicWithProgression = function() {
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("idle"), fetchStatus = ref1[0], setFetchStatus = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), topicWithProgress = ref2[0], setTopicWithProgress = ref2[1];
    var ref3 = (0,api_microlearning_useAPITopics__WEBPACK_IMPORTED_MODULE_3__/* .useGetTopicList */ .XI)(), topicsData = ref3.data, topicStatus = ref3.status;
    var ref4 = (0,api_microlearning_useAPIProgress__WEBPACK_IMPORTED_MODULE_2__/* .useGetTopicsProgress */ .v)(topicStatus === "success" && (topicsData === null || topicsData === void 0 ? void 0 : (ref = topicsData.data) === null || ref === void 0 ? void 0 : ref.length) > 0), progressData = ref4.data, progressStatus = ref4.status;
    /**
   * Let's define the cycle for fetching topics and its progress
   * the default FetchStatus is 'idle'
   * first we start by fetching the list of the topics,
   * change the FetchStatus to fetching_topics
   * when failed, set FetchStatus to error_fetching_topics - and STOP
   * when it is succeed, change the FetchStatus to topics_fetched
   * if current user is logged in (determined by "session" property)
   * then start fetching progress
   * when failed, set FetchStatus to error_fetching_progress
   */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        switch(topicStatus){
            case "loading":
                setFetchStatus("fetching_topics");
                break;
            case "error":
                setFetchStatus("error_fetching_topics");
                break;
            case "success":
                setFetchStatus(function() {
                    return topicsData.data.length > 0 ? "topics_fetched" : "success";
                });
                break;
        }
    }, [
        topicStatus,
        topicsData
    ]);
    /**
   * Since topics progress only fetched when user is loggedin and topic fetch
   * is successfully done, so we can safely assumed that the default state of the
   * fetch status at this point is always fetching progress
   */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        switch(progressStatus){
            default:
            case "loading":
                setFetchStatus("fetching_progress");
                break;
            case "success":
                setFetchStatus("success");
                break;
            case "error":
                setFetchStatus("error_fetching_progress");
                break;
        }
    }, [
        progressStatus
    ]);
    /**
   * When the overall fetch status is completed
   * now we can safely consolidating the progression data with the topics data
   */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (fetchStatus === "success") {
            var ref;
            //get each topic progression status from the progression data
            var topicsWithProgress = [];
            topicsData === null || topicsData === void 0 ? void 0 : (ref = topicsData.data) === null || ref === void 0 ? void 0 : ref.forEach(function(topic) {
                if (topic.totalModule > 0) {
                    var ref;
                    var currentTopicProgress = progressData === null || progressData === void 0 ? void 0 : (ref = progressData.data) === null || ref === void 0 ? void 0 : ref.find(function(progress) {
                        return topic.id === progress.id;
                    });
                    //determine the text for the badge
                    var topicProgressState = (0,app_PelatihanMandiriPage_helper__WEBPACK_IMPORTED_MODULE_1__/* .determineTopicState */ .h6)(currentTopicProgress);
                    switch(topicProgressState){
                        default:
                            topic.badge = undefined;
                            break;
                        case "MODULE_ON_PROGRESS":
                            topic.badge = {
                                type: "informational",
                                text: "Pelajari Modul"
                            };
                            break;
                        case "MODULE_DONE":
                        case "AKSI_NYATA_CREATED":
                        case "AKSI_NYATA_ON_PROGRESS":
                            topic.badge = {
                                type: "informational",
                                text: "Praktikkan Aksi Nyata",
                                state: "ongoing"
                            };
                            break;
                        case "AKSI_NYATA_NEED_REVISION":
                            topic.badge = {
                                type: "warning",
                                text: "Butuh perbaikan Aksi Nyata",
                                state: "ongoing"
                            };
                            break;
                        case "AKSI_NYATA_DONE":
                            topic.badge = {
                                type: "neutral",
                                text: "Menunggu hasil validasi",
                                state: "completed"
                            };
                            break;
                        case "AKSI_NYATA_APPEAL":
                            topic.badge = {
                                type: "neutral",
                                text: "Menunggu hasil banding",
                                state: "completed"
                            };
                            break;
                        case "AKSI_NYATA_VALIDATED":
                            if (!topic.certifiable) {
                                topic.badge = {
                                    type: "neutral",
                                    text: "Menunggu hasil validasi",
                                    state: "completed"
                                };
                                break;
                            }
                            topic.badge = {
                                type: "success",
                                text: "Sertifikat tersedia",
                                state: "validated"
                            };
                            break;
                    }
                    topicsWithProgress.push(topic);
                }
            });
            setTopicWithProgress(topicsWithProgress);
        }
    }, [
        fetchStatus,
        progressData === null || progressData === void 0 ? void 0 : progressData.data,
        topicsData === null || topicsData === void 0 ? void 0 : topicsData.data
    ]);
    return {
        topicWithProgress: topicWithProgress,
        fetchStatus: fetchStatus,
        progressData: progressData
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTopicWithProgression);


/***/ }),

/***/ 86315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_ForYou; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/hooks/context/useFeatureFlagContext.tsx + 1 modules
var useFeatureFlagContext = __webpack_require__(66578);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(98743);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/locale/id.js
var id = __webpack_require__(23260);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/utc.js
var utc = __webpack_require__(97046);
var utc_default = /*#__PURE__*/__webpack_require__.n(utc);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/timezone.js
var timezone = __webpack_require__(34646);
var timezone_default = /*#__PURE__*/__webpack_require__.n(timezone);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/hooks/useTopicWithProgression.tsx
var useTopicWithProgression = __webpack_require__(18248);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/partials/Topic/TopicPlaceholder.tsx
var TopicPlaceholder = __webpack_require__(25034);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(89004);
// EXTERNAL MODULE: ./node_modules/@wartek-id/icon/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(21958);
// EXTERNAL MODULE: ./components/Anchor/index.tsx
var Anchor = __webpack_require__(55231);
// EXTERNAL MODULE: ./utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(7379);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/LearningSeries/LearningSeriesCard.tsx
/* provided dependency */ var process = __webpack_require__(34155);








var LearningSeriesCard = function(param) {
    var id = param.id, title = param.title, figureImageUrl = param.figureImageUrl, topicsLength = param.topicsLength, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive;
    var href = "/".concat(process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/seri-pelatihan/").concat(id);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            "data-testid": "learning-series",
            className: (0,clsx_m/* default */.Z)("relative border rounded flex cursor-pointer appearance-none", isActive ? "border-primary bg-blue-10" : "bg-white border-subdued "),
            onClick: function() {
                (0,googleAnalytics/* GATrackEvent */.l)({
                    eventName: "learning_activity",
                    eventParams: {
                        event_trigger: "choose_series",
                        action_type: "choose_series",
                        meta: JSON.stringify({
                            series_id: id
                        })
                    },
                    sendDefaultParams: true
                });
            },
            href: href,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-1 flex-col pl-3 py-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex-1 line-clamp-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                variant: "heading-sm",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                                    fontSize: "small",
                                    children: "topic"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ml-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.x, {
                                        variant: "helper-bold",
                                        "data-testid": "topic-length",
                                        children: [
                                            topicsLength,
                                            " Topik"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex ml-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: figureImageUrl,
                        alt: "Figure Illustration",
                        width: 94,
                        height: 112,
                        unoptimized: true
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var LearningSeries_LearningSeriesCard = (LearningSeriesCard);

// EXTERNAL MODULE: ./app/PelatihanMandiriPage/components/GenericList.tsx
var GenericList = __webpack_require__(11145);
// EXTERNAL MODULE: ./components/EmptyState/index.ts + 1 modules
var EmptyState = __webpack_require__(99270);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/components/TabbedNav.tsx
var TabbedNav = __webpack_require__(18046);
// EXTERNAL MODULE: ./node_modules/querystring/index.js
var querystring = __webpack_require__(17673);
// EXTERNAL MODULE: ./node_modules/@wartek-id/button/dist/index.esm.js + 1 modules
var button_dist_index_esm = __webpack_require__(54204);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Topic/ContinueLearning.tsx
/* provided dependency */ var ContinueLearning_process = __webpack_require__(34155);








var ContinueLearning = function(param) {
    var topicsData = param.topicsData, progressData = param.progressData;
    var filteredProgress;
    try {
        // first we remove all topics with finished aksinyata and progress without topic ids
        filteredProgress = progressData.data.filter(function(progress) {
            return topicsData.filter(function(topic) {
                var ref, ref1;
                return (topic === null || topic === void 0 ? void 0 : (ref = topic.badge) === null || ref === void 0 ? void 0 : ref.state) !== "completed" && (topic === null || topic === void 0 ? void 0 : (ref1 = topic.badge) === null || ref1 === void 0 ? void 0 : ref1.state) !== "validated";
            }).map(function(topic) {
                return topic.id;
            }).includes(progress === null || progress === void 0 ? void 0 : progress.id);
        });
        if (filteredProgress.length === 0) {
            // bailout early if all of the topics are finished
            return null;
        }
        // then we sort them out by the number of modules with finished post test
        filteredProgress = filteredProgress.sort(function(a, b) {
            var aPostTestDoneCount = a.modules.filter(function(module) {
                return module.postTest === true;
            }).length / a.modules.length;
            var bPostTestDoneCount = b.modules.filter(function(module) {
                return module.postTest === true;
            }).length / b.modules.length;
            if (aPostTestDoneCount > bPostTestDoneCount) {
                return -1;
            } else if (aPostTestDoneCount < bPostTestDoneCount) {
                return 1;
            }
            return 0;
        });
        // check if there user at least has one finished modules (post test === true)
        var topicWithFinishedPostTestModule = filteredProgress.filter(function(progress) {
            return progress.modules.filter(function(module) {
                return module.postTest === true;
            }).length > 0;
        }).length;
        if (topicWithFinishedPostTestModule === 0) {
            filteredProgress = filteredProgress.sort(function(a, b) {
                var aMaterialDoneCount = a.modules.filter(function(module) {
                    return module.material === true;
                }).length / a.modules.length;
                var bMaterialDoneCount = b.modules.filter(function(module) {
                    return module.material === true;
                }).length / b.modules.length;
                if (aMaterialDoneCount > bMaterialDoneCount) {
                    return -1;
                } else if (aMaterialDoneCount < bMaterialDoneCount) {
                    return 1;
                }
                return 0;
            });
        }
        filteredProgress = filteredProgress.map(function(progress) {
            var currentTopic = topicsData.find(function(topic) {
                return topic.id === progress.id;
            });
            return {
                image: currentTopic === null || currentTopic === void 0 ? void 0 : currentTopic.headerImage,
                title: currentTopic === null || currentTopic === void 0 ? void 0 : currentTopic.name,
                id: progress.id,
                percentage: progress.percentage,
                module: progress.modules.filter(function(module) {
                    return module.postTest === false;
                }).sort(function(a, b) {
                    if (!!a.material && !b.material) {
                        return -1;
                    } else if (!!b.material && !a.material) {
                        return 1;
                    }
                    return 0;
                }).shift()
            };
        }).shift();
    } catch (e) {
        filteredProgress = null;
    }
    if (!!filteredProgress) {
        var destinationUrl = !filteredProgress.module ? "/".concat(ContinueLearning_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/topik/").concat(filteredProgress.id) : "/".concat(ContinueLearning_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/modul/").concat(filteredProgress.module.moduleId, "?").concat((0,querystring.stringify)({
            topik: filteredProgress.id,
            topik_name: filteredProgress.title
        }));
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            "data-testid": "continue-learning",
            className: "p-3 bg-white rounded border border-subdued mb-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between mb-4 w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-auto mr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                    variant: "helper",
                                    color: "subdued",
                                    children: !!filteredProgress.module ? "Modul" : "Aksi Nyata"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                    variant: "heading-sm",
                                    children: filteredProgress.title
                                })
                            ]
                        }),
                        !!filteredProgress.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "flex-grow-0 flex-shrink-0 w-[64px] h-[64px] rounded-sm object-cover object-center",
                            src: filteredProgress.image,
                            alt: filteredProgress.title
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center justify-center flex-grow-0 flex-shrink-0 w-[64px] h-[64px] bg-primary rounded-sm",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                                color: "inverse",
                                fontSize: "large",
                                children: "menu_book"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                        "data-testid": "link-target",
                        href: destinationUrl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, {
                            className: "rounded",
                            color: "black",
                            size: "lg",
                            fullWidth: true,
                            onClick: function() {
                                (0,googleAnalytics/* GATrackEvent */.l)({
                                    eventName: "learning_activity",
                                    eventParams: {
                                        event_trigger: "click_continue",
                                        action_type: "continue_sections",
                                        meta: JSON.stringify({
                                            destination_url: destinationUrl
                                        })
                                    },
                                    sendDefaultParams: true
                                });
                            },
                            children: !filteredProgress.module ? "Kerjakan Aksi Nyata" : !filteredProgress.module.material ? "Lanjut Pelajari" : "Kerjakan Post Test"
                        })
                    })
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ var Topic_ContinueLearning = (ContinueLearning);

// EXTERNAL MODULE: ./api/microlearning/useAPIKeyValue.ts
var useAPIKeyValue = __webpack_require__(42979);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/components/ListHeading.tsx



var ListHeading = function(param) {
    var title = param.title, detail = param.detail;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "mt-6 mb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                variant: "heading-lg",
                children: title
            }),
            !!detail && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                variant: "body-sm",
                color: "subdued",
                children: detail
            })
        ]
    });
};
/* harmony default export */ var components_ListHeading = (ListHeading);

// EXTERNAL MODULE: ./app/PelatihanMandiriPage/partials/Webinar/WebinarCard.tsx
var WebinarCard = __webpack_require__(9368);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/utils/webinar.ts
var utils_webinar = __webpack_require__(83682);
// EXTERNAL MODULE: ./types/microlearning.ts
var microlearning = __webpack_require__(69384);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/hooks/useTopicSurveyBanner.tsx




var useTopicSurveyBanner = function() {
    var ref = (0,useAPIKeyValue/* useGetKeyPairValue */.q8)(useAPIKeyValue/* MILKvKeys.TopicSurveyBanner */.QK.TopicSurveyBanner), data = ref.data, status = ref.status;
    var getSurveyBanner = function() {
        var topicProgress = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], options = arguments.length > 1 ? arguments[1] : void 0;
        var ref;
        if (status !== "success" || !(data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.active)) return null;
        var aksiNyataStatus = new Set(topicProgress.map(function(param) {
            var state = param.aksiNyata.state;
            return state;
        }));
        /** Should be ranked like this as the product specification stated */ var statusOrder = [
            microlearning/* AksiNyataSessionState.Validated */.OZ.Validated,
            microlearning/* AksiNyataSessionState.NeedRevision */.OZ.NeedRevision,
            microlearning/* AksiNyataSessionState.Completed */.OZ.Completed, 
        ];
        var url = function(surveyUrl) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = statusOrder[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var state = _step.value;
                    if (aksiNyataStatus.has(state)) {
                        return surveyUrl[state];
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return surveyUrl.DEFAULT;
        }(data.data.surveyUrl);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)(options === null || options === void 0 ? void 0 : options.className, "relative grid place-content-center"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: url,
                className: "overlay-link",
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: data.data.bannerUrl,
                    alt: "Survey Banner",
                    className: "w-full aspect-[336/92] max-w-md"
                })
            })
        });
    };
    return getSurveyBanner;
};
/* harmony default export */ var hooks_useTopicSurveyBanner = (useTopicSurveyBanner);

// EXTERNAL MODULE: ./app/PelatihanMandiriPage/helper.tsx + 1 modules
var helper = __webpack_require__(30469);
// EXTERNAL MODULE: ./hooks/useSafeRouter.ts
var useSafeRouter = __webpack_require__(28873);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/components/ForYou/Homepage.tsx
/* provided dependency */ var Homepage_process = __webpack_require__(34155);






















dayjs_min_default().extend((utc_default()));
dayjs_min_default().extend((timezone_default()));
dayjs_min_default().locale("id");
var WEBINAR_THRESHOLD_DEADLINE_MINUTES = 30;
var calculateTopicsLength = function(goals, topics) {
    var existingTopicIds = topics.map(function(topic) {
        return topic.id;
    }) // get list of topic ids from /topics endpoint
    ;
    return goals.map(function(goal) {
        var _draftTopics = goal.draftTopics, draftTopics = _draftTopics === void 0 ? [] : _draftTopics, topicIds = goal.topicIds;
        var draftTopicIds = draftTopics.map(function(draft) {
            return draft.id;
        }) // make array of draft topic ids
        ;
        var filteredTopicIds = topicIds.filter(function(id) {
            return existingTopicIds.includes(id) // compare non draft topic ids against topic ids from /topics (according to ACL)
            ;
        });
        return filteredTopicIds.concat(draftTopicIds) // join filtered topic ids with draft topic ids
        .filter(function(v, i, a) {
            return a.indexOf(v) === i;
        }) // remove duplicate
        ;
    }) // at this point, we already have an array of (for example) [[topic, ids, and, draft-topic, ids], [from, each, goal]]
    .flat().length // flatten the array to be single dimension [topic, ids, and, draft-topic, ids, from, each, goal] and return the length
    ;
};
var ForYouHomepage = function(param) {
    var _isDesktop = param.isDesktop, isDesktop = _isDesktop === void 0 ? false : _isDesktop, _currentId = param.currentId, currentId = _currentId === void 0 ? "" : _currentId;
    var ref, ref1, ref2;
    var safeReplace = (0,useSafeRouter/* useSafeRouter */._)().safeReplace;
    var ref3 = (0,react.useState)("idle"), dataState = ref3[0], setDataState = ref3[1];
    var ref4 = (0,useTopicWithProgression/* default */.Z)(), topicWithProgress = ref4.topicWithProgress, fetchStatus = ref4.fetchStatus, progressData = ref4.progressData;
    var learningSeries = (0,useAPIKeyValue/* useGetKeyPairValue */.q8)(useAPIKeyValue/* MILKvKeys.LearningSeries */.QK.LearningSeries);
    var learningSeriesData = (ref = learningSeries.data) === null || ref === void 0 ? void 0 : ref.data;
    var webinar = (0,useAPIKeyValue/* useGetKeyPairValue */.q8)(useAPIKeyValue/* MILKvKeys.WebinarEntries */.QK.WebinarEntries);
    var ref5;
    var webinarData = (ref5 = (ref1 = webinar.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.webinar) !== null && ref5 !== void 0 ? ref5 : [];
    var wibTime = dayjs_min_default()().tz("Asia/Jakarta");
    var webinarDataFiltered = webinar.status === "success" ? webinarData.filter(function(param) {
        var endDate = param.endDate;
        return wibTime.isBefore(dayjs_min_default()(endDate).add(WEBINAR_THRESHOLD_DEADLINE_MINUTES, "minute"));
    }) : [];
    var topicSurveyBanner = hooks_useTopicSurveyBanner();
    (0,react.useEffect)(function() {
        switch(fetchStatus){
            case "success":
                setDataState("success");
                break;
            case "fetching_topics":
            case "fetching_progress":
                setDataState("loading");
                break;
            case "error_fetching_progress":
            case "error_fetching_topics":
                setDataState("error");
                break;
        }
    }, [
        fetchStatus
    ]);
    var LearningSeriesList = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericList/* default */.Z, {
            data: learningSeriesData,
            dataState: dataState,
            listKey: function(param) {
                var id = param.id;
                return id;
            },
            beforeList: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ListHeading, {
                title: "Seri Pelatihan",
                detail: "Kumpulan topik-topik berkaitan yang sudah dikelompokkan ke dalam satu tema pembelajaran"
            }),
            errorComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyState */.ub, {
                fullscreen: false,
                title: "Data gagal dimuat",
                description: "Ada kesalahan pada sistem. Silakan coba beberapa saat lagi.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateAction */.Px, {
                    onClick: function() {
                        return window.location.reload();
                    },
                    children: "Muat Ulang"
                })
            }),
            emptyComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyState */.ub, {
                fullscreen: false,
                title: "Konten belum tersedia",
                description: "Belum ada seri pelatihan yang dapat diikuti saat ini. Silakan coba lagi nanti."
            }),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopicPlaceholder/* default */.Z, {
                amount: 3
            }),
            renderItem: function(param) {
                var id = param.id, title = param.title, figureImageUrl = param.figureImageUrl, goals = param.goals;
                var topicsLength = calculateTopicsLength(goals, topicWithProgress);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LearningSeries_LearningSeriesCard, {
                    id: id,
                    title: title,
                    figureImageUrl: figureImageUrl,
                    topicsLength: topicsLength,
                    isActive: currentId === id
                });
            },
            itemClassName: "mb-2"
        }, "learning-series");
    };
    if (isDesktop) {
        if (!currentId) {
            var firstLearningSeriesData = learningSeriesData === null || learningSeriesData === void 0 ? void 0 : learningSeriesData[0];
            (firstLearningSeriesData === null || firstLearningSeriesData === void 0 ? void 0 : firstLearningSeriesData.id) && safeReplace("/pelatihan-mandiri/seri-pelatihan/".concat(firstLearningSeriesData.id));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Pelatihan Mandiri | Untuk Anda"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-gray-10",
                    style: {
                        minHeight: "calc(100vh - 3.5rem)"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-3 pb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)((0,helper/* shouldHideNav */.J8)() ? "pt-3" : "pt-12"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LearningSeriesList, {})
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Pelatihan Mandiri | Untuk Anda"
                })
            }),
            !(0,helper/* shouldHideNav */.J8)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabbedNav/* default */.Z, {
                activeMenu: "untuk-anda",
                isHideScrollNav: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-gray-10",
                style: {
                    minHeight: "calc(100vh - 3.5rem)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-3 pb-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)((0,helper/* shouldHideNav */.J8)() ? "pt-3" : "pt-12"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_ContinueLearning, {
                                topicsData: topicWithProgress,
                                progressData: progressData
                            }),
                            topicSurveyBanner(progressData === null || progressData === void 0 ? void 0 : progressData.data, {
                                className: "my-6 first:mt-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LearningSeriesList, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericList/* default */.Z, {
                                data: webinarDataFiltered,
                                dataState: dataState,
                                listKey: function(param) {
                                    var id = param.id;
                                    return id;
                                },
                                beforeList: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ListHeading, {
                                    title: "Webinar"
                                }),
                                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarCard/* WebinarPreloader */.a, {}),
                                renderItem: function(param) {
                                    var id = param.id, title = param.title, topic = param.topic, speakers = param.speakers, startDate = param.startDate, endDate = param.endDate, module = param.module;
                                    var topicData = (0,utils_webinar/* getWebinarTopicData */.Y)({
                                        topikId: topic === null || topic === void 0 ? void 0 : topic.id,
                                        topikTitle: topic === null || topic === void 0 ? void 0 : topic.title
                                    }, topicWithProgress.map(function(param) {
                                        var id = param.id;
                                        return +id;
                                    }), module);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mb-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarCard/* default */.Z, {
                                            id: id,
                                            href: "/".concat(Homepage_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/webinar/").concat(id),
                                            topicId: "".concat(topicData === null || topicData === void 0 ? void 0 : topicData.topikId),
                                            topicName: topicData === null || topicData === void 0 ? void 0 : topicData.topikTitle,
                                            title: title,
                                            speakers: speakers,
                                            startDate: startDate,
                                            endDate: endDate
                                        })
                                    });
                                }
                            }, "webinar")
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Homepage = (ForYouHomepage);

// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@wartek-id/shimmer/dist/index.esm.js + 1 modules
var shimmer_dist_index_esm = __webpack_require__(28058);
// EXTERNAL MODULE: ./node_modules/@wartek-id/badge/dist/index.esm.js + 1 modules
var badge_dist_index_esm = __webpack_require__(10418);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/hooks/useSETrackEvent.ts + 2 modules
var useSETrackEvent = __webpack_require__(35917);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Topic/TopicNewest.tsx






var TopicNewest = function(param) {
    var topicData = param.topicData, title = param.title, isLoading = param.isLoading;
    var SETrackPromotionTopic = (0,useSETrackEvent/* useSETrackerEvent */.L)().SETrackPromotionTopic;
    var generateUrl = function(topicId) {
        return "/pelatihan-mandiri/topik/".concat(topicId);
    };
    var handleTracker = function(topic) {
        SETrackPromotionTopic({
            action_type: "click_promotion_topic",
            action_value: "click_topic",
            topic_id: topic.topicID
        });
    };
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                    className: "rounded-md mb-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "py-4 px-4 bg-white rounded-md border border-gray-20 relative h-28",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                        width: 120,
                                        className: "rounded-md mb-2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                        className: "rounded-md"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                className: "rounded-md",
                                height: 64,
                                width: 64
                            })
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://storage.googleapis.com/microlearning-public-production/web-assets/img-smartphone-star.png",
                            height: 24,
                            width: 24,
                            alt: "Topik Terbaru"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 ml-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-semibold text-lg",
                            children: title
                        })
                    })
                ]
            }),
            (topicData || []).map(function(topic, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-4",
                    onClick: function() {
                        return handleTracker(topic);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: generateUrl(topic.topicID),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-4 px-4 bg-white rounded-md border border-gray-20 relative",
                            children: [
                                topic.label && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_dist_index_esm/* Badge */.C, {
                                    className: "absolute -top-3 right-0 z-10",
                                    variant: "informational",
                                    children: topic.label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "font-semibold flex-1",
                                            children: topic.topicName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex-none",
                                            children: topic.imagePath && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: topic.imagePath,
                                                className: "rounded-md object-cover",
                                                height: 64,
                                                width: 64,
                                                alt: title
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center mt-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                                            fontSize: "small",
                                            children: "library_books"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-sm ml-2 font-semibold text-gray-60",
                                            children: [
                                                topic.totalModule,
                                                " modul"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }, "topic-newest-".concat(idx));
            })
        ]
    });
};
/* harmony default export */ var Topic_TopicNewest = (TopicNewest);

// EXTERNAL MODULE: ./utils/hooks/useLocalStorage.ts
var useLocalStorage = __webpack_require__(212);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Topic/TopicNewestList.tsx






var URL_TOPIC = "/pelatihan-mandiri/daftar-topik";
var TopicNewestList = function(param) {
    var items = param.items, isLoading = param.isLoading;
    var useFilter = (0,useLocalStorage/* useLocalStorage */._)("topic-sort-filter", "recommendation");
    var SETrackPromotionTopic = (0,useSETrackEvent/* useSETrackerEvent */.L)().SETrackPromotionTopic;
    var router = (0,next_router.useRouter)();
    var handleClickButton = function() {
        SETrackPromotionTopic({
            action_type: "click_promotion_topic",
            action_value: "view_all"
        });
        useFilter[1]("newest");
        router.push(URL_TOPIC);
    };
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_TopicNewest, {
            isLoading: true
        });
    }
    if (items && items.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-1 gap-4",
                    children: (items || []).map(function(item, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_TopicNewest, (0,_object_spread/* default */.Z)({}, item), idx);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "rounded-md border border-gray-50 text-center p-2 font-semibold",
                    onClick: function() {
                        return handleClickButton();
                    },
                    children: "Lihat topik lain"
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ var Topic_TopicNewestList = (TopicNewestList);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Topic/TopicRecommendation.tsx





var TopicRecommendation = function(param) {
    var title = param.title, subtitle = param.subtitle, contextualizePages = param.contextualizePages, isLoading = param.isLoading;
    var SETrackRecommendationCollection = (0,useSETrackEvent/* useSETrackerEvent */.L)().SETrackRecommendationCollection;
    var items = contextualizePages || [];
    var generateUrl = function(contextualizedId) {
        return "/pelatihan-mandiri/contextualized-learning/".concat(contextualizedId);
    };
    var handleTracker = function(item) {
        SETrackRecommendationCollection({
            action_type: "click_theme_collection",
            action_value: "click_theme",
            contextualized_page_id: item.id,
            contextualized_page_name: item.pageTitle
        });
    };
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                    className: "rounded-md mb-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "py-4 px-4 bg-white rounded-md border border-gray-20 relative h-28",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                        width: 120,
                                        className: "rounded-md mb-2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                        className: "rounded-md"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                className: "rounded-md",
                                height: 64,
                                width: 64
                            })
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://storage.googleapis.com/microlearning-public-production/web-assets/img-book-literature.png",
                                    height: 24,
                                    width: 24,
                                    alt: "Topik Bertema"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1 ml-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-semibold text-lg",
                                    children: title
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "leading-relaxed text-gray-70 text-sm",
                            children: subtitle
                        })
                    })
                ]
            }),
            items.map(function(item, idx) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    onClick: function() {
                        return handleTracker(item);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: generateUrl(item.id),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-4 px-4 bg-white rounded-md border border-gray-20 relative mb-4",
                            children: [
                                item.label && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_dist_index_esm/* Badge */.C, {
                                    className: "absolute -top-3 right-0 z-10",
                                    variant: "informational",
                                    children: item.label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-md font-semibold flex-1",
                                                    children: item === null || item === void 0 ? void 0 : item.pageTitle
                                                }),
                                                item.pageExcerpt && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "leading-relaxed text-gray-70 line-clamp-2 text-sm",
                                                    children: item.pageExcerpt
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex-none ml-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: item.pageThumbnailUrl,
                                                className: "rounded-md h-[64px] w-[64px] object-cover",
                                                alt: item === null || item === void 0 ? void 0 : item.pageTitle
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }, "recommendation-".concat(idx));
            })
        ]
    });
};
/* harmony default export */ var Topic_TopicRecommendation = (TopicRecommendation);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Topic/InfoBox.tsx



var TOPIC_URL = "/pelatihan-mandiri/daftar-topik";
var InfoBox = function(param) {
    var _isShowButton = param.isShowButton, isShowButton = _isShowButton === void 0 ? true : _isShowButton, _title = param.title, title = _title === void 0 ? "Belum ada topik yang anda pelajari" : _title, _description = param.description, description = _description === void 0 ? "Cobalah temukan di halaman daftar topik" : _description, _isError = param.isError, isError = _isError === void 0 ? false : _isError;
    var image = isError ? "https://storage.googleapis.com/microlearning-public-production/web-assets/img-error-fixing.png" : "https://storage.googleapis.com/microlearning-public-production/web-assets/img-magnifying-document.png";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white border rounded-md p-4 border-gray-30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: image,
                alt: "empty-topic",
                width: 48,
                height: 48
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "font-semibold text-lg",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-sm text-gray-60",
                children: description
            }),
            isShowButton && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: TOPIC_URL,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, {
                    className: "mt-4",
                    fullWidth: true,
                    color: "black",
                    children: "Lihat daftar topik"
                })
            })
        ]
    });
};
/* harmony default export */ var Topic_InfoBox = (InfoBox);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Topic/TopicRecommendationList.tsx




var TopicRecommendationList = function(param) {
    var items = param.items, isLoading = param.isLoading, isError = param.isError;
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_TopicRecommendation, {
            isLoading: true
        });
    }
    if (items && items.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "grid grid-cols-1 gap-4",
            children: (items || []).map(function(item, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_TopicRecommendation, (0,_object_spread/* default */.Z)({}, item), idx);
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-start mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://storage.googleapis.com/microlearning-public-production/web-assets/img-book-literature.png",
                            height: 24,
                            width: 24,
                            alt: "Topik Bertema"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 ml-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-semibold text-lg",
                            children: "Rekomendasi belajar"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_InfoBox, {
                title: !isError ? "Belum ada rekomendasi belajar" : "Terjadi masalah dalam memuat rekomendasi belajar",
                description: !isError ? "Cobalah temukan di halaman daftar topik" : "Silakan coba lagi dalam beberapa saat.",
                isError: isError,
                isShowButton: !isError
            })
        ]
    });
};
/* harmony default export */ var Topic_TopicRecommendationList = (TopicRecommendationList);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Topic/TopicProgress.tsx







var LoadingComponent = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
            className: "rounded-md mb-2"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "py-4 px-4 bg-white rounded-md border border-gray-20 relative h-28",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                width: 120,
                                className: "rounded-md mb-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                className: "rounded-md"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                        className: "rounded-md",
                        height: 64,
                        width: 64
                    })
                ]
            })
        })
    ]
});
var TopicProgress = function(param) {
    var isLoading = param.isLoading, selectedProgress = param.selectedProgress, isError = param.isError;
    var // sorted modules by id
    ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var SETrackProgressTopic = (0,useSETrackEvent/* useSETrackerEvent */.L)().SETrackProgressTopic;
    if (isLoading) {
        return LoadingComponent;
    }
    selectedProgress === null || selectedProgress === void 0 ? void 0 : (ref = selectedProgress.modules) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
        return b.moduleId - a.moduleId;
    });
    var status = (selectedProgress === null || selectedProgress === void 0 ? void 0 : selectedProgress.percentage) !== 100 ? "IN_PROGRESS" : selectedProgress === null || selectedProgress === void 0 ? void 0 : (ref1 = selectedProgress.aksiNyata) === null || ref1 === void 0 ? void 0 : ref1.state;
    var title = status === "IN_PROGRESS" ? "MODUL" : "TOPIK";
    var notLearnedModule = (selectedProgress === null || selectedProgress === void 0 ? void 0 : (ref2 = selectedProgress.modules) === null || ref2 === void 0 ? void 0 : ref2.find(function(module) {
        return module.postTest === false && module.prerequisiteCompleted === true;
    })) || (selectedProgress === null || selectedProgress === void 0 ? void 0 : selectedProgress.modules[0]);
    var modulCount = {
        total: selectedProgress === null || selectedProgress === void 0 ? void 0 : (ref3 = selectedProgress.modules) === null || ref3 === void 0 ? void 0 : ref3.length,
        learned: (ref5 = selectedProgress === null || selectedProgress === void 0 ? void 0 : (ref4 = selectedProgress.modules) === null || ref4 === void 0 ? void 0 : ref4.filter(function(module) {
            return module.postTest;
        })) === null || ref5 === void 0 ? void 0 : ref5.length
    };
    var content = {
        image: status === "IN_PROGRESS" ? notLearnedModule === null || notLearnedModule === void 0 ? void 0 : notLearnedModule.imagePath : selectedProgress === null || selectedProgress === void 0 ? void 0 : selectedProgress.imageUrl,
        title: status === "IN_PROGRESS" ? notLearnedModule === null || notLearnedModule === void 0 ? void 0 : notLearnedModule.name : selectedProgress === null || selectedProgress === void 0 ? void 0 : selectedProgress.name
    };
    var URL_CONTINUE = {
        NOT_CREATED: "/pelatihan-mandiri/topik/".concat(selectedProgress === null || selectedProgress === void 0 ? void 0 : selectedProgress.id, "/aksi-nyata?topik_name=").concat(selectedProgress === null || selectedProgress === void 0 ? void 0 : selectedProgress.name),
        CREATED: "/pelatihan-mandiri/topik/".concat(selectedProgress === null || selectedProgress === void 0 ? void 0 : selectedProgress.id, "/aksi-nyata?topik_name=").concat(selectedProgress === null || selectedProgress === void 0 ? void 0 : selectedProgress.name),
        CONFIRMED: "/pelatihan-mandiri/topik/".concat(selectedProgress === null || selectedProgress === void 0 ? void 0 : selectedProgress.id, "/aksi-nyata/form"),
        NEED_REVISION: "/pelatihan-mandiri/topik/".concat(selectedProgress === null || selectedProgress === void 0 ? void 0 : selectedProgress.id, "/aksi-nyata/form"),
        IN_PROGRESS: "/pelatihan-mandiri/modul/".concat(notLearnedModule === null || notLearnedModule === void 0 ? void 0 : notLearnedModule.moduleId)
    };
    var URL_TOPIC = "/pelatihan-mandiri/topik/".concat(selectedProgress === null || selectedProgress === void 0 ? void 0 : selectedProgress.id);
    var CIRCLE_ICON = {
        NOT_CREATED: {
            name: "batch_prediction",
            variant: "inverse",
            color: "#103178"
        },
        CREATED: {
            name: "batch_prediction",
            variant: "inverse",
            color: "#103178"
        },
        CONFIRMED: {
            name: "batch_prediction",
            variant: "inverse",
            color: "#103178"
        },
        IN_PROGRESS: {
            name: "lock",
            variant: "disabled",
            color: "#ffffff"
        },
        NEED_REVISION: {
            name: "border_color",
            variant: "inverse",
            color: "#FFC453"
        }
    };
    var BUTTON_TEXT = {
        NOT_CREATED: "Lanjut Aksi Nyata",
        CREATED: "Lanjut Aksi Nyata",
        CONFIRMED: "Lanjut Aksi Nyata ",
        IN_PROGRESS: "Lanjut pelajari ",
        NEED_REVISION: "Perbaiki Aksi Nyata"
    };
    var handleTrackerOpenTopic = function() {
        SETrackProgressTopic({
            action_type: "click_progress_topic",
            action_value: "buka_topik",
            destination_url: URL_TOPIC
        });
    };
    var handleTrackerToActivity = function() {
        SETrackProgressTopic({
            action_type: "click_progress_topic",
            action_value: "to_activity",
            destination_url: URL_CONTINUE[status]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-start mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://storage.googleapis.com/microlearning-public-production/web-assets/progress-topic-icon.png",
                            height: 24,
                            width: 24,
                            alt: "Topik Progress"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 ml-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-semibold text-lg",
                            children: "Progres topik Anda sebelumnya"
                        })
                    })
                ]
            }),
            !!selectedProgress && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white rounded-md border border-gray-20 relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-md font-semibold text-gray-60 text-sm",
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "font-semibold flex-1",
                                                children: content.title
                                            })
                                        ]
                                    }),
                                    content.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-none ml-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: content.image,
                                            className: "rounded-md h-[64px] w-[64px] object-cover",
                                            alt: content.title
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative h-[6px] w-full rounded-md bg-gray-40 mt-4",
                                children: [
                                    status !== "IN_PROGRESS" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute h-[21px] w-[21px] rounded-full top-0 bottom-0 m-auto left-0 border-2 border-white flex items-center justify-center z-10 bg-green-50",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                                            style: {
                                                fontSize: "12px"
                                            },
                                            color: (ref6 = CIRCLE_ICON[status]) === null || ref6 === void 0 ? void 0 : ref6.variant,
                                            children: "check"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute h-full left-0 bg-green-50 rounded-md",
                                        style: {
                                            width: "".concat((selectedProgress === null || selectedProgress === void 0 ? void 0 : selectedProgress.percentage) / 1.5, "%")
                                        }
                                    }),
                                    status === "NEED_REVISION" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute h-full right-0 bg-yellow-300 rounded-md",
                                        style: {
                                            width: "calc(50% / 1.5)"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute h-[21px] w-[21px] rounded-full top-0 bottom-0 m-auto right-0 border-2 border-white flex items-center justify-center",
                                        style: {
                                            backgroundColor: (ref7 = CIRCLE_ICON[status]) === null || ref7 === void 0 ? void 0 : ref7.color,
                                            left: "36%"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                                            style: {
                                                fontSize: "10px"
                                            },
                                            color: (ref8 = CIRCLE_ICON[status]) === null || ref8 === void 0 ? void 0 : ref8.variant,
                                            children: (ref9 = CIRCLE_ICON[status]) === null || ref9 === void 0 ? void 0 : ref9.name
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between mt-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "font-semibold text-sm flex-1",
                                        children: [
                                            modulCount.learned,
                                            "/",
                                            modulCount.total,
                                            " modul dipelajari"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-sm font-semibold",
                                        style: {
                                            width: "calc((50% / 1.5) + 6px)"
                                        },
                                        children: "Aksi Nyata"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "p-4 border-t-gray-20 border",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: function() {
                                        return handleTrackerOpenTopic();
                                    },
                                    className: "flex-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: URL_TOPIC,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, {
                                            color: "white",
                                            fullWidth: true,
                                            children: "Buka Topik"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: function() {
                                        return handleTrackerToActivity();
                                    },
                                    className: "ml-2 flex-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: URL_CONTINUE[status],
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, {
                                            color: "black",
                                            fullWidth: true,
                                            children: BUTTON_TEXT[status]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            !selectedProgress && /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_InfoBox, {
                isError: isError,
                title: !isError ? "Belum ada topik yang anda pelajari" : "Terjadi masalah dalam memuat progres",
                description: !isError ? "Cobalah temukan di halaman daftar topik" : "Silakan coba lagi dalam beberapa saat.",
                isShowButton: !isError
            })
        ]
    });
};
/* harmony default export */ var Topic_TopicProgress = (TopicProgress);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Topic/Webinar.tsx
/* provided dependency */ var Webinar_process = __webpack_require__(34155);








var TopicWebinar = function(param) {
    var items = param.items, isLoading = param.isLoading, isError = param.isError;
    var SETrackWebinar = (0,useSETrackEvent/* useSETrackerEvent */.L)().SETrackWebinar;
    var WEBINAR_THRESHOLD_DEADLINE_MINUTES = 30;
    var wibTime = dayjs_min_default()().tz("Asia/Jakarta");
    var webinarDataFiltered = !isLoading ? items.filter(function(param) {
        var endDate = param.endDate;
        return wibTime.isBefore(dayjs_min_default()(endDate).add(WEBINAR_THRESHOLD_DEADLINE_MINUTES, "minute"));
    }) : [];
    var fetchState = isLoading ? "loading" : "success";
    var handleTracker = function(title) {
        SETrackWebinar({
            action_type: "click_webinar",
            action_value: title
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-start mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://storage.googleapis.com/microlearning-public-production/web-assets/webinar-icon.png",
                            height: 24,
                            width: 24,
                            alt: "Webinar"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 ml-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "font-semibold text-lg",
                            children: [
                                "Webinar",
                                webinarDataFiltered.length ? " (".concat(webinarDataFiltered.length, ")") : ""
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericList/* default */.Z, {
                data: webinarDataFiltered,
                dataState: fetchState,
                listKey: function(param) {
                    var id = param.id;
                    return id;
                },
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarCard/* WebinarPreloader */.a, {}),
                renderItem: function(param) {
                    var id = param.id, title = param.title, speakers = param.speakers, startDate = param.startDate, endDate = param.endDate, module = param.module;
                    var topicData = module[0];
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-2",
                        onClick: function() {
                            return handleTracker(title);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarCard/* default */.Z, {
                            id: id,
                            href: "/".concat(Webinar_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/webinar/").concat(id),
                            topicId: "".concat(topicData === null || topicData === void 0 ? void 0 : topicData.topikId),
                            topicName: topicData === null || topicData === void 0 ? void 0 : topicData.topikTitle,
                            title: title,
                            speakers: speakers,
                            startDate: startDate,
                            endDate: endDate,
                            isShowNameSpeakers: false
                        })
                    });
                },
                emptyComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_InfoBox, {
                    title: !isError ? "Belum ada jadwal webinar terbaru" : "Terjadi masalah dalam memuat webinar",
                    description: !isError ? "Jadwal webinar yang tersedia akan tampil disini" : "Silakan coba lagi dalam beberapa saat.",
                    isError: isError,
                    isShowButton: false
                })
            }, "webinar")
        ]
    });
};
/* harmony default export */ var Webinar = (TopicWebinar);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Topic/TopicMore.tsx



var url = "/pelatihan-mandiri/daftar-topik";
var TopicMore = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-lg font-semibold",
                children: "Tidak menemukan topik yang Anda cari?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-2 text-sm text-gray-60",
                children: "Cobalah temukan di halaman daftar topik"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: url,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, {
                    color: "black",
                    fullWidth: true,
                    children: "Lihat daftar topik"
                })
            })
        ]
    });
};
/* harmony default export */ var Topic_TopicMore = (TopicMore);

// EXTERNAL MODULE: ./api/microlearning/useAPITopics.ts
var useAPITopics = __webpack_require__(14644);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/components/ForYou/HomepageRevamp.tsx













var ForYouRevamp = function(param) {
    var isDesktop = param.isDesktop;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var SETrackTopNav = (0,useSETrackEvent/* useSETrackerEvent */.L)().SETrackTopNav;
    var topicSurveyBanner = hooks_useTopicSurveyBanner();
    var getTopicNewest = (0,useAPITopics/* useTopicNewest */.MD)();
    var getTopicRecommendation = (0,useAPITopics/* useTopicRecommendation */.oq)();
    var getTopicProgress = (0,useAPITopics/* useTopicProgress */.Lr)();
    var getWebinar = (0,useAPIKeyValue/* useGetKeyPairValue */.q8)(useAPIKeyValue/* MILKvKeys.WebinarEntries */.QK.WebinarEntries);
    var handleScrollClicked = function(param) {
        var label = param.label;
        SETrackTopNav({
            action_type: "click_top_nav",
            action_value: label
        });
    };
    /* FOR PROGRESS TOPIC */ // first we sorting percentage progress highest to lowest
    var sortedProgress = getTopicProgress === null || getTopicProgress === void 0 ? void 0 : (ref = getTopicProgress.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.sort(function(a, b) {
        return b.percentage - a.percentage;
    });
    // we get the first progress that has percentage 100 and aksi nyata state is NOT_CREATED, NEED_REVISION, CONFIRMED, CREATED
    var selectedProgress = (sortedProgress === null || sortedProgress === void 0 ? void 0 : sortedProgress.find(function(item) {
        return item.percentage === 100 && [
            "NOT_CREATED",
            "CONFIRMED",
            "CREATED",
            "NEED_REVISION"
        ].includes(item.aksiNyata.state);
    })) || (sortedProgress === null || sortedProgress === void 0 ? void 0 : sortedProgress.find(function(item) {
        return item.percentage < 100 && item.percentage > 1 && item.modules.find(function(module) {
            return module.postTest === false && module.prerequisiteCompleted === true;
        });
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Pelatihan Mandiri | Untuk Anda"
                })
            }),
            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabbedNav/* default */.Z, {
                activeMenu: "untuk-anda",
                scrollClicked: handleScrollClicked
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-gray-10",
                style: {
                    minHeight: "calc(100vh - 3.5rem)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: isDesktop ? "px-3 pb-5" : "px-3 pb-5 pt-40",
                    children: [
                        topicSurveyBanner(getTopicProgress === null || getTopicProgress === void 0 ? void 0 : (ref2 = getTopicProgress.data) === null || ref2 === void 0 ? void 0 : ref2.data, {
                            className: "my-6 first:mt-0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_TopicNewestList, {
                                isLoading: getTopicNewest.isLoading,
                                items: (getTopicNewest === null || getTopicNewest === void 0 ? void 0 : (ref3 = getTopicNewest.data) === null || ref3 === void 0 ? void 0 : ref3.data) || []
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                            name: "rekomendasi-belajar",
                            className: "pb-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_TopicRecommendationList, {
                                isLoading: getTopicRecommendation.isLoading,
                                items: (getTopicRecommendation === null || getTopicRecommendation === void 0 ? void 0 : (ref4 = getTopicRecommendation.data) === null || ref4 === void 0 ? void 0 : ref4.data) || [],
                                isError: getTopicRecommendation.isError
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                            name: "progress-topik",
                            className: "pb-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_TopicProgress, {
                                isLoading: getTopicProgress.isLoading,
                                selectedProgress: selectedProgress,
                                isError: getTopicProgress.isError
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                            name: "webinar",
                            className: "pb-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Webinar, {
                                items: (getWebinar === null || getWebinar === void 0 ? void 0 : (ref5 = getWebinar.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : ref6.webinar) || [],
                                isLoading: getWebinar.isLoading,
                                isError: getWebinar.isError
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_TopicMore, {})
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var HomepageRevamp = (ForYouRevamp);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/pages/ForYou.tsx




var ForYou = function(param) {
    var isDesktop = param.isDesktop, currentId = param.currentId;
    var getFeatureByKey = (0,useFeatureFlagContext/* useFeatureFlagContext */.dG)().getFeatureByKey;
    var isEnablePelatihanMandiriRevamp = getFeatureByKey("enablePelatihanMandiriRevamp");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: isEnablePelatihanMandiriRevamp ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageRevamp, {
            isDesktop: isDesktop
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Homepage, {
            isDesktop: isDesktop,
            currentId: currentId
        })
    });
};
/* harmony default export */ var pages_ForYou = (ForYou);


/***/ }),

/***/ 25034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28058);




var TopicPlaceholder = function(param) {
    var _amount = param.amount, amount = _amount === void 0 ? 1 : _amount;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        role: "alert",
        "aria-label": "alert",
        "aria-busy": "true",
        children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Array(amount)).map(function(_, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative mb-3 last:mb-0 rounded-lg overflow-hidden shadow-card",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "p-4 bg-white",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_3__/* .Shimmer */ .q, {
                                style: {
                                    width: "100%"
                                },
                                height: 18
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex -mx-2 mb-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center px-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_3__/* .Shimmer */ .q, {
                                        width: 36,
                                        height: 16
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center px-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_3__/* .Shimmer */ .q, {
                                        width: 36,
                                        height: 16
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb-4",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_3__/* .Shimmer */ .q, {
                                style: {
                                    width: "100%"
                                },
                                height: 16
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-wrap items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-[140px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_3__/* .Shimmer */ .q, {
                                        width: 140,
                                        height: 16
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "ml-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_3__/* .Shimmer */ .q, {
                                        width: 88,
                                        height: 16
                                    })
                                })
                            ]
                        })
                    ]
                })
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TopicPlaceholder);


/***/ }),

/***/ 9368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ WebinarPreloader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98743);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97046);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34646);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var dayjs_locale_id__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23260);
/* harmony import */ var dayjs_locale_id__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_id__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86010);
/* harmony import */ var _wartek_id_text__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89004);
/* harmony import */ var _wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28058);
/* harmony import */ var _wartek_id_avatar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42586);
/* harmony import */ var utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7379);
/* harmony import */ var components_Anchor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55231);
/* harmony import */ var app_PelatihanMandiriPage_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30469);
/* provided dependency */ var process = __webpack_require__(34155);














dayjs__WEBPACK_IMPORTED_MODULE_2___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3___default()));
dayjs__WEBPACK_IMPORTED_MODULE_2___default().extend((dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4___default()));
dayjs__WEBPACK_IMPORTED_MODULE_2___default().locale("id");
var WebinarPreloader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative rounded border border-subdued bg-white px-4 py-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__/* .Shimmer */ .q, {
                className: "mb-2",
                height: 14,
                style: {
                    width: "50%"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__/* .Shimmer */ .q, {
                className: "mb-4",
                height: 16,
                style: {
                    width: "100%"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__/* .Shimmer */ .q, {
                className: "mb-4",
                height: 14,
                style: {
                    width: "100%"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__/* .Shimmer */ .q, {
                        className: "mb-4",
                        height: 14,
                        style: {
                            width: "30%"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__/* .Shimmer */ .q, {
                        className: "mb-4",
                        height: 14,
                        width: 100
                    })
                ]
            })
        ]
    });
};
var WebinarCard = function(param) {
    var id = param.id, href = param.href, topicName = param.topicName, topicId = param.topicId, title = param.title, speakers = param.speakers, startDate = param.startDate, endDate = param.endDate, _active = param.active, active = _active === void 0 ? false : _active, _isShowNameSpeakers = param.isShowNameSpeakers, isShowNameSpeakers = _isShowNameSpeakers === void 0 ? true : _isShowNameSpeakers;
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().pathname;
    var speakersName = speakers.map(function(speaker) {
        return speaker.name;
    }).join(", ");
    var startDateObj = dayjs__WEBPACK_IMPORTED_MODULE_2___default()(startDate);
    var endDateObj = dayjs__WEBPACK_IMPORTED_MODULE_2___default()(endDate);
    var eventDate = {
        day: startDateObj.format("D"),
        month: startDateObj.format("MMM"),
        time: "".concat(startDateObj.tz("Asia/Jakarta").format("HH:mm"), " - ").concat(endDateObj.tz("Asia/Jakarta").format("HH:mm"), " WIB")
    };
    var AvatarProfile = function(param) {
        var name = param.name, image = param.image, index = param.index;
        if (image) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    transform: "translate(-".concat((index + 1) * 3, "px, 3px)")
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,app_PelatihanMandiriPage_helper__WEBPACK_IMPORTED_MODULE_9__/* .cacheImage */ .qM)(image),
                    alt: name,
                    className: "rounded-full bg-transparent h-9 w-9"
                })
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_avatar__WEBPACK_IMPORTED_MODULE_11__/* .Avatar */ .q, {
            name: name,
            alt: name,
            src: "",
            style: {
                transform: "translate(-".concat((index + 1) * 3, "px,0)")
            }
        }, index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "data-testid": "webinar",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("relative rounded border border-subdued bg-white p-3", active && "border-primary bg-blue-20"),
        children: [
            !!topicName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                variant: "eyebrow-sm",
                color: "subdued",
                children: topicName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Anchor__WEBPACK_IMPORTED_MODULE_8__/* .Anchor */ .e, {
                href: href,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    onClick: function() {
                        (0,utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_7__/* .GATrackEvent */ .l)({
                            eventName: "learning_activity",
                            eventParams: {
                                event_trigger: "webinar_list",
                                action_type: pathname === "/".concat(process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/webinar") ? "click_webinar_from_list" : "click_webinar_from_topic",
                                meta: JSON.stringify({
                                    id: id,
                                    title: title,
                                    topik: topicName,
                                    topik_id: topicId
                                })
                            },
                            sendDefaultParams: true
                        });
                    },
                    className: "overlay-link mb-2 block leading-none",
                    href: href,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                        as: "span",
                        variant: "heading-sm",
                        children: title
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-3",
                children: isShowNameSpeakers && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                    as: "div",
                    variant: "helper",
                    color: "subdued",
                    className: "leading-none",
                    children: speakersName
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-wrap items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex w-1/2 flex-shrink-0 items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "z-10 flex h-9 w-9 items-center justify-center rounded-full border bg-white",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "py-1",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                                            as: "div",
                                            variant: "body-sm",
                                            className: "text-center leading-none",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                children: eventDate.day
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "-mt-1 text-[8px] font-semibold uppercase",
                                            children: eventDate.month
                                        })
                                    ]
                                })
                            }),
                            speakers.map(function(param, index) {
                                var name = param.name, avatar = param.avatar;
                                return index < 3 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AvatarProfile, {
                                    name: name,
                                    image: avatar,
                                    index: index
                                }) : null;
                            }),
                            speakers.length > 3 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "z-0 flex h-9 w-9 items-center justify-center rounded-full border bg-gray-20",
                                style: {
                                    transform: "translate(-15px,0)"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                                    variant: "body-sm",
                                    className: "text-subdued",
                                    children: [
                                        "+",
                                        speakers.length - 3
                                    ]
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-1/2 flex-shrink-0 flex-grow-0 text-right",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                            variant: "body-sm",
                            color: "subdued",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-semibold",
                                children: eventDate.time
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WebinarCard);


/***/ }),

/***/ 83682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getWebinarTopicData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);


var getWebinarTopicData = function(originalTopicData, topicIds, webinarModules) {
    if (!!originalTopicData.topikId && !!originalTopicData.topikTitle) {
        return {
            topikTitle: originalTopicData.topikTitle,
            topikId: originalTopicData.topikId
        };
    }
    var topicData = webinarModules.reduce(function(topicData, module) {
        if (topicIds.includes(module.topikId)) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(topicData).concat([
                {
                    topikTitle: module.topikTitle,
                    topikId: module.topikId
                }, 
            ]);
        }
        return topicData;
    }, []);
    /** Return null if user has more than topic title (user is multi-jenjang) */ if (topicData.length > 1) return null;
    var _topicData = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(topicData, 1), topicDatum = _topicData[0];
    return topicDatum;
};


/***/ }),

/***/ 55231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_androidHandler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84494);






var Anchor = function(props) {
    var href = props.href, children = props.children, linkProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "href",
        "children"
    ]);
    var androidHandler = (0,utils_androidHandler__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)();
    var isAndroid = androidHandler.enabled;
    if (isAndroid) {
        // if children tag is anchor tag, return it
        if (children && typeof children === "object") {
            var child = children;
            if (child.type === "a") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: children
                });
            }
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            href: href
        }, linkProps), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        href: href
    }, linkProps), {
        children: children
    }));
};


/***/ })

}]);